import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext(null);
const KEY = "aicom_app_theme";

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    try { return localStorage.getItem(KEY) || "light"; } catch { return "light"; }
  });

  useEffect(() => {
    try { localStorage.setItem(KEY, theme); } catch (e) { void e; }
  }, [theme]);

  const setTheme = (t) => setThemeState(t === "light" ? "light" : "dark");
  const toggleTheme = () => setThemeState((t) => (t === "dark" ? "light" : "dark"));

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
